export default "__VITE_ASSET__Bwfl0Okr__"